import { Loader } from 'braid-design-system';

import { useSelf } from '../../../../../hooks/self.ts';

export const HomeMenuItemLabel = () => {
  const { self, loading } = useSelf();
  return loading ? (
    <Loader size="xsmall" />
  ) : (
    <>{self?.partner.name ? self.partner.name : 'Developer Dashboard'}</>
  );
};
